// extracted by mini-css-extract-plugin
export default {"form":"SubForm_form__FNsVz","formContainer":"SubForm_formContainer__tzfiJ","body":"SubForm_body__T0aF3","formBody":"SubForm_formBody__J5qEX"};